import styled from "styled-components/macro";
import { WxText } from "../..";
import { __ } from "../../../i18n/l10n";
import { breakpoint } from "../../../styles/constants";

export const CartDesktopBar = () => {
  return (
    <Wrapper>
      <div>
        <WxText text={__("Items")} bold darkMode />
      </div>
      <div>
        <WxText text={__("Description")} bold darkMode />
      </div>
      <div>
        <WxText text={""} bold darkMode />
      </div>
      <div>
        <WxText text={__("Quantity")} bold darkMode />
      </div>
      <div>
        <WxText text={__("Price")} bold darkMode align="right" />
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: none;

  @media (min-width: ${breakpoint}) {
    display: flex;

    justify-content: space-between;
    padding-bottom: 0.625rem;
    border-bottom: 1px solid ${({ theme }) => theme.colors.white};
    > div {
      flex: 1;
      text-align: left;

      > * {
        width: unset;
      }
    }
    > div:last-child {
      text-align: end;
    }
  }
`;
